import type { TopicId } from "../types/dashboard";
import { cardsForTopic, groupCardsByRow } from "../registry/cardRegistry";
import { topicById } from "../registry/topics";
import { EcgDataProvider } from "../context/EcgDataContext";
import { ViewHeader } from "./ViewHeader";

function needsEcgData(topicId: TopicId): boolean {
  return topicId === "ecg" || topicId === "frequency";
}

export function MainArea({ topicId }: { topicId: TopicId }) {
  const topic = topicById(topicId);
  const cards = cardsForTopic(topicId);
  const rows = groupCardsByRow(cards);
  const fillViewport = topicId === "devops";

  const content = (
    <div
      className={
        fillViewport
          ? "flex min-h-0 flex-1 flex-col"
          : "flex flex-col gap-[var(--space-section)]"
      }
    >
      {[...rows.entries()].map(([rowKey, { label, cards: rowCards }]) => (
        <section
          key={rowKey}
          className={fillViewport ? "flex min-h-0 flex-1 flex-col" : undefined}
        >
          {label && rowKey !== "hero" && (
            <h2
              className="mb-2 font-semibold text-text-primary"
              style={{ fontSize: "var(--font-heading)" }}
            >
              {label}
            </h2>
          )}
          <div
            className={
              fillViewport
                ? "flex min-h-0 flex-1 flex-col"
                : rowKey === "hero"
                  ? "w-full"
                  : rowKey === "tiles"
                    ? "flex flex-wrap gap-3"
                    : "flex flex-col gap-3"
            }
          >
            {rowCards.map((card) => (
              <div
                key={card.id}
                className={
                  fillViewport
                    ? "flex min-h-0 flex-1 flex-col"
                    : rowKey === "hero" || rowKey === "tiles"
                      ? "w-full"
                      : ""
                }
              >
                {card.render()}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );

  return (
    <main
      className={
        fillViewport
          ? "flex min-h-0 flex-1 flex-col overflow-hidden bg-page p-0"
          : "min-h-0 flex-1 overflow-y-auto bg-page p-3 lg:p-[var(--space-section)]"
      }
    >
      {!fillViewport && topicId !== "frequency" ? <ViewHeader topic={topic} /> : null}
      {needsEcgData(topicId) ? <EcgDataProvider>{content}</EcgDataProvider> : content}
    </main>
  );
}
